import React from 'react';
import { useTranslation } from 'react-i18next';
import { Body, Grid, Heading } from '@walmart-web/livingdesign-components';

import styles from './styles.module.css';

const NoResults = () => {
  const { t } = useTranslation('profile');

  return (
    <Grid UNSAFE_className={styles.noResultsContainer}>
      <img src="/assets/images/notifications/fish_circle.png" />
      <Grid UNSAFE_className={styles.msgContainer}>
        <Heading>{t('notifications.noResults.title')}</Heading>
        <Body size="medium">{t('notifications.noResults.message')}</Body>
      </Grid>
    </Grid>
  );
};

export default NoResults;
